import CompetitionLogInModal from "./CompetitionLogInModal";

export default CompetitionLogInModal;